module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-modal', {
    attrs: {
      "id": "edit-widgets-modal",
      "title": "EDIT WIDGETS",
      "value": _vm.value,
      "extra-class": "modal-sm"
    },
    on: {
      "save": function($event) {
        return _vm.$emit('save', _vm.widgets)
      },
      "input": function($event) {
        return _vm.$emit('input', $event)
      }
    }
  }, _vm._l((Object.keys(_vm.widgets)), function(widget) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "mt-checkbox no-margin-bot",
      attrs: {
        "for": widget + '-widget'
      }
    }, [_vm._v(_vm._s(widget) + "\n      "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.widgets[widget]),
        expression: "widgets[widget]"
      }],
      staticClass: "widget-enabled-checkbox",
      attrs: {
        "type": "checkbox",
        "id": widget + '-widget'
      },
      domProps: {
        "value": widget,
        "checked": Array.isArray(_vm.widgets[widget]) ? _vm._i(_vm.widgets[widget], widget) > -1 : (_vm.widgets[widget])
      },
      on: {
        "change": function($event) {
          var $$a = _vm.widgets[widget],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = widget,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.widgets, widget, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.widgets, widget, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.widgets, widget, $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span')])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00c18772","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/EditWidgetsModal.vue
// module id = 1533
// module chunks = 1